<template>
  <div class="district__nav u-absolute u-marg-t-md u-pointer-all">
    <div v-if="!$device.isTablet">
      <router-link @click.native="$ga.send('District', 'Click', 'City button')" :to="$local('city')" title="City" class="district__nav__btn-back t-button--simple u-relative u-bg-grey u-block">
        <img src="/images/btn-city.png" alt="" class="district__nav__btn-back__ico u-absolute u-w4of12">
      </router-link>
    </div>
    <div class="u-flex u-middle">
      <button class="district__nav__controls__btn t-button--simple u-relative u-inline-block" @click="onPrev">
        <img src="/images/arrow-left.svg" alt="" class="district__nav__controls__btn__ico u-absolute">
      </button>
      <div class="district__nav__title t-button u-inline-block u-white u-center u-marg-x-sm u-center">
        <span class="t-text--xsmall u-relative u-uppercase u-block">District</span>
        <span class="t-text--big u-relative u-inline-block u-uppercase u-overflow-hidden">
          <span v-for="(district, index) in districts" class="district__nav__label u-inline-block u-nowrap" ref="title" :class="[ index === wilderTitleIndex || wilderTitleIndex === -1 ? 'u-relative' : 'u-absolute is-absolute u-full-width' ]" :style="{ transform: 'translateY(' + (index * 100 - activeDistricIndex * 100) + '%) translateZ(0)' }">{{district.title}}</span>
        </span>
      </div>
      <button class="district__nav__controls__btn t-button--simple u-relative u-inline-block" @click="onNext">
        <img src="/images/arrow-right.svg" alt="" class="district__nav__controls__btn__ico u-absolute">
      </button>
    </div>
  </div>
</template> 

<script>
export default {
  props: {
    content: {
      type: Object,
      default: null
    }
  },

  computed: {
    districts() {
      return this.$store.getters['data/districts']
    },

    activeDistricIndex() {
      return this.districts.findIndex(district => { return district.slug === this.$route.params.slug })
    }
  },

  data()
  {
    return {
      wilderTitleIndex: -1
    }
  },

  mounted()
  {
    this.onResize()
  },

  methods:
  {
    onResize() {
      this.wilderTitleIndex = -1
      let maxWidthTitle = 0

      this.$nextTick(() => {
        for(let i = 0; i < this.$refs.title.length; i++) {
          if(this.$refs.title[i].offsetWidth > maxWidthTitle) {
            maxWidthTitle = this.$refs.title[i].offsetWidth
            this.wilderTitleIndex = i
          }
        }
      })
    },
    onPrev () {
      this.$ga.send('District', 'Click', 'Left arrow navigation')
      this.$emit('onPrev')
    },
    onNext () {
      this.$ga.send('District', 'Click', 'Right arrow navigation')
      this.$emit('onNext')
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/mixins/viewport-sizer'
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

    
.district__nav
  top 0
  left 0
  transform translateX(calc(-50% + (100vw / 8) * 4)) translateZ(0)
  transition transform 1.15s 0s ease-in-out-quint
  
  @media ( max-width: $mq-breakpoints.mobile )
    margin-top 110px
  
  &.is-panel-active
    transform translateX(calc(-50% + ((100vw / 8) * 5) / 2)) translateZ(0)
    
    @media ( max-width: $mq-breakpoints.tablet )
      transform translateX(calc(-50% + ((100vw / 8) * 4) / 2)) translateZ(0)
      
    @media ( max-width: $mq-breakpoints.mobile )
      transform translateX(calc(-50% + (100vw / 8) * 4)) translateZ(0)
  
.district__nav__btn-back
  width 74px
  height 74px
  border-radius 50%
  margin 0 auto 10px auto
  
.district__nav__btn-back__ico
  top 50%
  left 50%
  transform translate(-50%, -50%)

.district__nav__title
  padding 10px 30px 8px 30px!important
  
.district__nav__label
  top 0
  left 0
  margin auto
  transition transform .8s ease-out-quint
  
.district__nav__controls__btn
  width 40px
  height 40px
  border 2px solid $colors.white
  border-radius 50%
  
.district__nav__controls__btn__ico
  width 10px
  top 50%
  left 50%
  transform translate(-50%, -50%)

</style>